import React, { useEffect, useState } from 'react'
import { Nav, Navbar, NavDropdown, Form, FormControl, Button, Container } from 'react-bootstrap'
import MCLogo from '../assets/images/logo.png'
import Phone from '../assets/images/telephone-white.png'
import Bell from '../assets/images/Bell_Icon_White.png'

const styles = {
    navBar: {
        padding: "1rem 1rem"
    }, 
    navLink: {
        padding: '20px',
    }
}
export function HeaderComponent(props) {
    return (<>
        {
            <div className='banner'>
                {/* <div className="top-sec fixed" style={{marginRight: '5%'}}>
                    <span className="log">
                        <span className="user_iconn">
                            <a href="https://www.customer.manipalcigna.com/user/login">Login</a>
                        </span>
                    </span>
                    <span className='lang'>
                        <div className="notifyBtnClass">
                            <img src={Bell} height='25px' width='23px' />
                        </div>
                    </span>
                    <ul className="menu_lists">
                        <li className="mob_hide tab_hide ml_1">To Renew:</li>
                        <li><a href="tel:1800 102 4465">
                            <div className="mob_hide tab_hide phone_icon">
                                <img src={Phone} height='15px' width='15px' />
                            </div>

                        </a>
                            <span className="d-inline-block"></span>
                            <a href="tel:1800 102 4465" className="text-white tab_hide mob_hide">
                                1800 102 4465</a>
                        </li>
                        <li className="mob_hide tab_hide ml_1">For Service:</li>
                        <li><a href="tel:1800 102 4462">
                            <div className="phone_icon">
                                <img src={Phone} height='15px' width='15px' />
                            </div>
                        </a>
                            <span className="d-inline-block"></span>
                            <a href="tel:1800 102 4462" className="text-white tab_hide mob_hide">
                                1800 102 4462</a>
                        </li>
                        <li className="mob_hide tab_hide ml_1">To Buy:</li>
                        <li><a href="tel:1800 102 4464">
                            <div className="mob_hide tab_hide phone_icon">
                                <img src={Phone} height='15px' width='15px' />
                            </div>
                        </a>
                            <span className="d-inline-block"></span>
                            <a href="tel:1800 102 4464" className="text-white tab_hide mob_hide">
                                1800 102 4464</a>
                        </li>
                        <li>
                            <a href="https://buyonline.manipalcigna.com/buy-health-insurance/Group-Insurance" className="text-white">Groups</a>
                        </li>
                    </ul>
                </div> */}

                <Navbar expand="lg" className="menu_bar" style={styles.navBar}>
                    <Navbar.Brand href= {process.env.REACT_APP_CURRENT_ENVIRONMENT_HOME} style={{marginLeft: '3%'}}>
                        <img src={MCLogo} />
                    </Navbar.Brand>
                    {/* <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll" style={{ justifyContent: 'end' }}>

                        <Nav
                            className="my-2 my-lg-0"
                            //style={{ maxHeight: '100px' }}
                            navbarScroll>

                            <Nav.Link href="#action1" className=" top_list haveChild" style={styles.navLink}></Nav.Link>
                            <NavDropdown title="Products" id="navbarScrollingDropdown" style={styles.navLink}></NavDropdown>
                            <NavDropdown title="Renewal" id="navbarScrollingDropdown" style={styles.navLink}>
                                <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                                <NavDropdown.Item href="#action4">Another action</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="#action5">Something else here</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link href="#action2" style={styles.navLink}>Claims</Nav.Link>
                            <Nav.Link href="#action2" style={styles.navLink}>Learn</Nav.Link>
                            <Nav.Link href="#action2" style={styles.navLink}>Wellness</Nav.Link>
                            <Nav.Link href="#action2" style={styles.navLink}>About Us</Nav.Link>
                            <Nav.Link href="#" style={styles.navLink}>Support</Nav.Link>
                        </Nav>
                    </Navbar.Collapse> */}
                </Navbar>
                <div className='m-t-8'></div>
            </div>
        }
    </>
    )
}

